import { render } from "./icon-exclamation-mark.vue?vue&type=template&id=5c9690c5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__